var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalletConnect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 22,
    viewBox: "0 0 36 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_544_4448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.34841 4.2991C13.2021 -1.43248 22.6929 -1.43248 28.5465 4.2991L29.2515 4.98847C29.5447 5.27451 29.5447 5.74008 29.2515 6.02612L26.8411 8.38625C26.6951 8.52987 26.4569 8.52987 26.3109 8.38625L25.3414 7.43717C21.2579 3.43859 14.6371 3.43859 10.5523 7.43717L9.51347 8.45327C9.36745 8.59689 9.12929 8.59689 8.98327 8.45327L6.57527 6.09314C6.28204 5.8071 6.28204 5.34153 6.57527 5.05549L7.34841 4.2991ZM33.5313 9.17855L35.676 11.279C35.9692 11.565 35.9692 12.0306 35.676 12.3166L26.0045 21.7859C25.7113 22.0719 25.2373 22.0719 24.9441 21.7859L18.0803 15.0657C18.0073 14.9939 17.8888 14.9939 17.8158 15.0657L10.9509 21.7859C10.6576 22.0719 10.1837 22.0719 9.89047 21.7859L0.21894 12.3166C-0.074282 12.0306 -0.074282 11.565 0.21894 11.279L2.36365 9.17855C2.65687 8.89251 3.13081 8.89251 3.42403 9.17855L10.2878 15.8999C10.3608 15.9717 10.4793 15.9717 10.5523 15.8999L17.4161 9.17855C17.7093 8.89251 18.1833 8.89251 18.4765 9.17855L25.3403 15.8999C25.4133 15.9717 25.5317 15.9717 25.6048 15.8999L32.4685 9.17974C32.7641 8.89251 33.2381 8.89251 33.5313 9.17855Z",
    fill: "#3B99FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_544_4448"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.8951,
    height: 22,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletConnect);
export default __webpack_public_path__ + "static/media/WalletConnect.d0813aa73028f2dd03895f218d0e254a.svg";
export { ForwardRef as ReactComponent };